import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Booking(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#273B7D" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <g clipPath="url(#clip0_10222_142985)">
        <path
          d="M10.3994 15.9731H8.38425V13.5628C8.38425 13.0492 8.58181 12.7726 9.02435 12.7172H10.4073C10.6249 12.6992 10.8439 12.7289 11.0489 12.8042C11.2539 12.8795 11.44 12.9986 11.5943 13.1532C11.7485 13.3078 11.8672 13.4942 11.942 13.6994C12.0167 13.9046 12.0459 14.1236 12.0273 14.3412C12.0273 15.3685 11.407 15.981 10.4073 15.981L10.3994 15.9731ZM8.38029 9.45745V8.82525C8.38029 8.27207 8.61737 8.00338 9.13103 7.97177H10.1663C11.0514 7.97177 11.5887 8.50124 11.5887 9.39423C11.5887 10.0659 11.2252 10.8562 10.2058 10.8562H8.3882L8.38029 9.45745ZM12.9796 11.8677L12.6161 11.6623L12.9322 11.3857C13.3036 11.0696 13.92 10.3504 13.92 9.11369C13.92 7.21708 12.4501 5.99219 10.1781 5.99219H7.2937C6.96798 6.00338 6.65917 6.1399 6.43169 6.37328C6.2042 6.60665 6.07562 6.91885 6.07275 7.24474V17.9922H10.2295C12.7583 17.9922 14.3862 16.6171 14.3862 14.4835C14.3862 13.3376 13.8607 12.3498 12.9717 11.8559"
          fill="white"
        />
        <path
          d="M15.0425 16.55C15.0425 15.7479 15.6865 15.0999 16.4847 15.0999C17.2828 15.0999 17.9348 15.7479 17.9348 16.55C17.9348 17.3521 17.2868 18.0001 16.4847 18.0001C15.6826 18.0001 15.0425 17.3521 15.0425 16.55Z"
          fill="#499FDD"
        />
      </g>
      <defs>
        <clipPath id="clip0_10222_142985">
          <rect fill="white" height="12" transform="translate(6 6)" width="12" />
        </clipPath>
      </defs>
    </svg>
  );
}

Booking.propTypes = propTypes;
Booking.defaultProps = defaultProps;

export default Booking;
